import { render, staticRenderFns } from "./CommentEditPanel.vue?vue&type=template&id=5e14bfb2&"
import script from "./CommentEditPanel.vue?vue&type=script&lang=js&"
export * from "./CommentEditPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports